const port = parseInt(process.env.NEXT_PUBLIC_PORT, 10) || 3067;

const conf = {
  basePath: process.env.NEXT_PUBLIC_BASE_PATH || '',
  port,
  node_url: 'https://maimai.cn',
  inner_node_url: 'http://front:8544',
  inner_online_url: 'http://front:8540',
  localhost_url: `http://localhost:${port}`,
};

export default conf;
